import { render, staticRenderFns } from "./TripleElipse.vue?vue&type=template&id=495c97d2"
import script from "./TripleElipse.vue?vue&type=script&lang=js"
export * from "./TripleElipse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports